(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gdl-celebrity-group"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('gdl-celebrity-group')){
 customElements.define('gdl-celebrity-group',class extends HTMLElement{
  connectedCallback(){
   this.controller?.abort();
   this.controller=new AbortController();
   const options={signal:this.controller.signal};
   this.dialog=this.querySelector('.gdl-portrait-dialog');
   this.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-gdl-portrait]');
    if(!trigger||!this.contains(trigger))return;
    event.preventDefault();
    this.lastTrigger=trigger;
    const photo=new Image();
    photo.alt=trigger.dataset.name;
    photo.src=trigger.dataset.image;
    this.dialog.querySelector('.gdl-portrait-image').replaceChildren(photo);
    this.dialog.querySelector('.gdl-portrait-name').textContent=trigger.dataset.name;
    this.dialog.querySelector('.gdl-portrait-role').textContent=trigger.dataset.role;
    if(!this.dialog.open)this.dialog.showModal();
   },options);
   this.dialog.querySelector('.gdl-portrait-close').addEventListener('click',()=>this.dialog.close(),options);
   this.dialog.addEventListener('click',event=>{
    const r=this.dialog.getBoundingClientRect();
    if(event.target===this.dialog&&(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom))this.dialog.close();
   },options);
   this.dialog.addEventListener('close',()=>this.lastTrigger?.focus({preventScroll:true}),options);
   if(!('IntersectionObserver' in window)||matchMedia('(prefers-reduced-motion: reduce)').matches||window.Shopify?.designMode)return;
   this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.remove('gdl-pending');entry.target.classList.add('gdl-revealed');this.observer.unobserve(entry.target);}});},{threshold:.08});
   this.querySelectorAll('[data-gdl-card]').forEach(card=>{if(card.getBoundingClientRect().top>innerHeight){card.classList.add('gdl-pending');this.observer.observe(card);}});
  }
  disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.controller?.abort();this.observer?.disconnect();this.querySelectorAll('.gdl-pending').forEach(card=>card.classList.remove('gdl-pending'));}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gdl-celebrity-index"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gdl-celebrity-index')) {
 customElements.define('gdl-celebrity-index', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const options = {signal:this.controller.signal};
   this.frame = 0;
   this.update = () => { if(!this.frame) this.frame=requestAnimationFrame(()=>{this.frame=0;this.measure();}); };
   this.refresh = () => {
    this.links = [...this.querySelectorAll('a[href^="#"]')];
    let number=1;
    document.querySelectorAll('[data-gdl-group]').forEach(group=>{
     group.querySelectorAll('[data-gdl-number]').forEach(item=>{item.textContent=String(number++).padStart(2,'0');});
    });
    this.links.forEach(link=>{
     const group=document.getElementById(link.hash.slice(1));
     if(group){link.querySelector('[data-gdl-count]').textContent=group.querySelectorAll('[data-gdl-card]').length;group.style.scrollMarginTop=(parseFloat(getComputedStyle(this.parentElement).top)||0)+this.offsetHeight+24+'px';}
    });
    this.measure();
   };
   this.addEventListener('click',event=>{
    const link=event.target.closest('a[href^="#"]');
    if(!link || !this.contains(link))return;
    const group=document.getElementById(link.hash.slice(1));
    if(!group)return;
    event.preventDefault();
    group.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
    history.replaceState(null,'',link.hash);
    const heading=group.querySelector('h2');
    if(heading){heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
   },options);
   window.addEventListener('scroll',this.update,{...options,passive:true});
   window.addEventListener('resize',this.refresh,options);
   ['shopify:section:load','shopify:section:unload','shopify:section:reorder'].forEach(name=>document.addEventListener(name,this.refresh,options));
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.refresh,options);else this.refresh();
  }
  measure(){
   if(!this.links?.length)return;
   let current=this.links[0];
   const line=Math.max(innerHeight*.35,(parseFloat(getComputedStyle(this.parentElement).top)||0)+this.offsetHeight+30);
   this.links.forEach(link=>{const group=document.getElementById(link.hash.slice(1));if(group && group.getBoundingClientRect().top<=line)current=link;});
   this.links.forEach(link=>{if(link===current)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
   if(this.current!==current){const rail=this.querySelector('ul'),r=rail.getBoundingClientRect(),e=current.getBoundingClientRect();if(e.left<r.left+8||e.right>r.right-8)rail.scrollLeft+=e.left-r.left-72;this.current=current;}
  }
  disconnectedCallback(){this.controller?.abort();cancelAnimationFrame(this.frame);}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jwc-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jwc-announcement')) {
 customElements.define('jwc-announcement', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.abort=new AbortController();
   const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:this.abort.signal});
   this.items=[...this.querySelectorAll('[data-message]')];this.track=this.querySelector('.jn-track');this.index=0;this.hover=false;this.focused=false;this.editing=false;
   this.wide=matchMedia('(min-width:750px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
   on(this.wide,'change',()=>this.render());on(this.reduced,'change',()=>this.render());
   on(this.querySelector('[data-prev]'),'click',()=>this.move(-1));on(this.querySelector('[data-next]'),'click',()=>this.move(1));
   on(this,'pointerenter',e=>{if(e.pointerType==='mouse'){this.hover=true;this.schedule();}});on(this,'pointerleave',()=>{this.hover=false;this.schedule();});
   on(this,'pointerdown',e=>{if(e.pointerType!=='mouse'){this.hover=false;this.focused=false;this.schedule();}});
   on(this,'focusin',()=>{this.focused=document.activeElement?.matches(':focus-visible')||false;this.schedule();});on(this,'focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement)&&(document.activeElement?.matches(':focus-visible')||false);this.schedule();}));
   on(document,'visibilitychange',()=>this.schedule());
   let start=null;
   on(this,'touchstart',e=>{if(e.touches.length===1)start={x:e.touches[0].clientX,y:e.touches[0].clientY};});
   on(this,'touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))this.move(dx<0?1:-1);});
   on(this,'shopify:block:select',e=>{const i=this.items.findIndex(item=>item===e.target||item.contains(e.target));if(i>=0){this.editing=true;this.index=i;this.render();}});
   on(this,'shopify:block:deselect',()=>{this.editing=false;this.schedule();});
   this.spacer=document.createElement('div');
   this.spacer.setAttribute('aria-hidden','true');this.spacer.style.pointerEvents='none';
   document.body.append(this.spacer);
   this.resizeObserver=new ResizeObserver(()=>this.syncSpace());this.resizeObserver.observe(this);
   on(window,'resize',()=>this.syncSpace());
   this.render();this.syncSpace();
  }
  syncSpace(){if(this.spacer)this.spacer.style.height=`${this.getBoundingClientRect().height}px`;}
  isTogether(){return this.dataset.layout==='together'&&this.wide.matches;}
  move(delta){if(this.isTogether())return;this.index=(this.index+delta+this.items.length)%this.items.length;this.render();}
  render(){
   const together=this.isTogether(),multiple=this.items.length>1;
   this.track.style.transform=together?'none':`translateX(-${this.index*100}%)`;
   this.items.forEach((item,i)=>{const active=together||i===this.index;item.setAttribute('aria-hidden',String(!active));item.inert=!active;});
   this.querySelectorAll('[data-prev],[data-next]').forEach(b=>b.hidden=together||!multiple||this.dataset.arrows!=='true');
   this.schedule();
  }
  schedule(){clearTimeout(this.timer);if(this.dataset.autoplay==='true'&&this.items.length>1&&!this.isTogether()&&!this.hover&&!this.focused&&!this.editing&&!this.reduced.matches&&!document.hidden)this.timer=setTimeout(()=>this.move(1),Number(this.dataset.duration)||7000);}
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.resizeObserver?.disconnect();this.spacer?.remove();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.classList.add('products-loaded');
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
